import {put, takeEvery, select} from 'redux-saga/effects';
import {loadFile, uploadRecurrentProblemFile} from '../api/restFile';
import {errorAlert} from '../actions/alertsActions';
import {extractErrorText} from '../actions/actionUtils';
import FileSaver from 'file-saver';
import alertMessages from '../intl/common/alertMessages';
import {FILE_UPLOAD_STATUS} from '../actions/actionFile';
import {aseWebsocketCommands} from '../constants/aseWebsocketCommands';

function* handleUploadRecurrentProblemFile(action) {
    try {
        const fileToUpload = yield select(state => state.mainFiles.attachmentsToBeUploaded.get(action.payload.attachment.attachmentId));
        yield uploadRecurrentProblemFile(action.payload.attachment.url, fileToUpload.localFileUrl, fileToUpload.contentType);
        window.URL.revokeObjectURL(fileToUpload.localFileUrl);
        yield put({
            type: FILE_UPLOAD_STATUS,
            payload: {uuid: action.payload.attachment.attachmentId, status: 'DONE'}
        });
    } catch (e) {
        yield put(errorAlert(...extractErrorText(e, alertMessages.FILE_UPLOAD_ERROR)));
    }
}

function* handleDownloadRecurrentProblemFile(action) {
    try {
        const file = yield loadFile(action.payload.attachment.url);
        const fileToDownload = yield select(state => state.mainFiles.attachmentsToBeDownloaded.get(action.payload.attachment.attachmentId));
        FileSaver.saveAs(file.data, fileToDownload.name);
    } catch (e) {
        yield put(errorAlert(...extractErrorText(e, alertMessages.FILE_DOWNLOAD_ERROR)));
    }
}

function* recurrentProblemFileSaga() {
    yield takeEvery(aseWebsocketCommands.ASE_RECURRENT_PROBLEMS_ATTACHMENTS_UPLOAD, handleUploadRecurrentProblemFile);
    yield takeEvery(aseWebsocketCommands.ASE_RECURRENT_PROBLEMS_ATTACHMENTS_DOWNLOAD, handleDownloadRecurrentProblemFile);
}

export default recurrentProblemFileSaga;
